if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const requestedMediaId = this.openedBy?.getAttribute('data-media-id');
        this.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('active');
        });

        const activeMedia =
          this.querySelector(`[data-media-id="${requestedMediaId}"]:not([hidden])`) ||
          this.querySelector('[data-media-id]:not([hidden])');
        if (!activeMedia) {
          return;
        }

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView({ block: 'center', inline: 'center' });

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();
      }
    }
  );
}
